<div class="inputTitle m-no" *ngIf="label">
    <span>{{ label }}<i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
                        id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>
<div class="viewLable w-100i" [ngSwitch]="label" *ngIf="!showPurpose">
    <span *ngSwitchDefault>{{ name }}</span>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'POL(s)'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'Pick-up Location'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'Buy Location'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'On-hire Location'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'POD(s)'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'Drop-off Location'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'Sell Location'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div class="listStyle" [class.expandedList]="viewmore" *ngSwitchCase="'Off-hire Location'">
        <li *ngIf="list?.length">
            {{ list[0][displayField] }}
            <ng-container *ngIf="list?.length>1">
                <p [matTooltip]="list | tooltipList " matTooltipClass="tooltip-list" [matTooltipHideDelay]="delay">
                    + {{ list?.length - 1 }} more
                </p>
            </ng-container>
        </li>
    </div>
    <div *ngSwitchCase="'Equipment'">
        <ng-container *ngIf="!lead">
            <span *ngFor="let item of list; let last =last;">
                {{ item[displayField] }}{{ space1 }}{{ item[displayField1] ? item[displayField1][displayField2] : '' }}
                {{ space2 }}{{ item[displayField3] ? item[displayField3][displayField4] : '' }}{{ space3 }}{{ !last ? ',&nbsp;' : '.' }}
            </span>
        </ng-container>
        <ng-container *ngIf="lead">
            <span>{{ displayField }}</span>
        </ng-container>
    </div>
    <div *ngSwitchCase="'Posted By'">
        <span *ngIf="name!=null && name[displayField]!=null">{{ name[displayField][displayField1] }}
            {{ name[displayField][displayField2] }}</span><br>
        <span
            *ngIf="name!=null && name[displayField]!=null && name[displayField][displayField3]!=null">{{ name[displayField][displayField3][displayField4] }}</span>
    </div>
    <div *ngSwitchCase="'Posted On'">
        <span>{{ date | date:"dd MMM yyyy, hh:mm a" }}</span>
    </div>
    <div *ngSwitchCase="'Last Updated By'">
        <ng-container *ngIf="name != null">
            <span *ngIf="name[displayField]==null">-</span>
            <span *ngIf="name[displayField]!=null">
                {{ name[displayField][displayField1] }} {{ name[displayField][displayField2] }}
            </span>
        </ng-container>
    </div>
    <div *ngSwitchCase="'Approved by'">
        <span *ngIf="name==null">-</span>
        <span *ngIf="name!=null">
            {{ name[displayField1] }} {{ name[displayField2] }}
        </span>
    </div>
    <div *ngSwitchCase="'Rejected by'">
        <span *ngIf="name!=null">
            {{ name[displayField1] }} {{ name[displayField2] }}
        </span>
    </div>
    <div *ngSwitchCase="'Rejection Reason'">
        <span *ngIf="name==null">-</span>
        <span *ngIf="name!=null">
            {{ name[displayField1] }}
        </span>
    </div>
    <div *ngSwitchCase="'DPP/Container'">
        <span *ngIf="name==null">-</span>
        <span *ngIf="name!=null">
            {{ name[displayField1] }} {{ name[displayField2] }}
        </span>
    </div>
    <div *ngSwitchCase="'Insurance Charge'">
        <span *ngIf="name==null">-</span>
        <span *ngIf="name!=null && name[displayField]==null">
            {{ name[displayField1] }} {{ name[displayField2] }}
        </span>
    </div>
    <div *ngSwitchCase="'Last Updated On'">
        <span>{{ date | date:"dd MMM yyyy, hh:mm a" }}</span>
    </div>
    <div *ngSwitchCase="'Request Date'">
        <span>{{ date | date:"dd MMM yyyy, hh:mm a" }}</span>
    </div>
    <div *ngSwitchCase="'Requestor Email'">
        <span *ngIf="name!=null && name[displayField]!=null" class="lb-aw">
            {{ name[displayField1] == null ? name[displayField][displayField1] : name[displayField1] }}</span>
    </div>
    <div *ngSwitchCase="'Requestor Name'">
        <!-- <span *ngIf="name!=null && name[displayField]!=null" class="lb-aw">
            {{name[displayField1]==null ? name[displayField][displayField1] : name[displayField1]}}</span> -->
        <span *ngIf="name!=null && name[displayField]!=null">
            {{ name[displayField][displayField1] }} {{ name[displayField][displayField2] }}
        </span>
    </div>
    <div *ngSwitchCase="'Requestor Company'">
        <span *ngIf="name!=null && name[displayField]!=null && name[displayField][displayField1]!=null"
              class="lb-aw">{{
                name[displayField][displayField1][displayField2] != null &&
                name[displayField][displayField1][displayField2] != '' ? name[displayField][displayField1][displayField2] :
                    '-'
            }}</span>
    </div>
    <div *ngSwitchCase="'Lessee Company'">
        <span *ngIf="name!=null && name[displayField]!=null && name[displayField][displayField1]!=null"
              class="lb-aw">{{
                name[displayField][displayField1][displayField2] != null &&
                name[displayField][displayField1][displayField2] != '' ? name[displayField][displayField1][displayField2] :
                    '-'
            }}</span>
    </div>
    <div *ngSwitchCase="'Leasing Period'">
        <span class="lb-aw">{{ name }}</span>
    </div>
    <div *ngSwitchCase="'Master Agreement No.'">
        <span *ngIf="name!=null && name[displayField]!=null && name[displayField][displayField1]!=null"
              class="lb-aw">{{
                name[displayField][displayField1][displayField2] != null &&
                name[displayField][displayField1][displayField2] != '' ? name[displayField][displayField1][displayField2] :
                    '-'
            }}</span>
    </div>
    <div *ngSwitchCase="'Agreement Valid till'">
        <span *ngIf="name!=null && name[displayField]!=null && name[displayField][displayField1]!=null"
              class="lb-aw">{{
                name[displayField][displayField1][displayField2] != null &&
                name[displayField][displayField1][displayField2] != '' ? (name[displayField][displayField1][displayField2] |
                        date:"dd MMM, yyyy") :
                    '-'
            }}</span>
    </div>
    <div *ngSwitchCase="'Remarks'">
        <span *ngIf="name!=null" class="lb-aw">{{ name[displayField] == null ? 'OK' : name[displayField] }}</span>
    </div>
    <div *ngSwitchCase="'Lead Entry Source'">
        <span *ngIf="name!=null" class="lb-aw">
            {{ name[displayField] && name[displayField] != '' ? name[displayField] : '-' }}
        </span>
    </div>
    <div *ngSwitchCase="'Old booking Number'">
        <span *ngIf="name!=null" class="lb-aw">
            {{ name[displayField] != null && name[displayField] != '' ? name[displayField] : '-' }}
        </span>
    </div>
    <div *ngSwitchCase="'Reference No./Referrer'">
        <span *ngIf="name!=null" class="lb-aw">
            {{ name[displayField] != null && name[displayField] != '' ? name[displayField] : '-' }}
        </span>
    </div>
    <!-- Display Field on MNR container Details -->

    <div *ngSwitchCase="'Container size-type'">
        <span *ngIf="name!=null && name[displayField]!=null">
            {{ name[displayField] }}
        </span>
    </div>
    <div *ngSwitchCase="'Container Grade'">
        <span *ngIf="name[displayField]==null">-</span>
        <span *ngIf="name!=null && name[displayField]!=null">
            {{ name[displayField] }}
        </span>
    </div>

    <div *ngSwitchCase="'Depot Name'">
        <span *ngIf="name!=null && name[displayField]!=null">
            {{ name[displayField] }}
        </span>
    </div>
    <!-- <div *ngSwitchCase="'Activity Location'">
        <span *ngIf="name!=null" class="lb-aw">
            {{name[displayField] && name[displayField]!='' ? name[displayField] : '-'}}
        </span>
    </div> -->
    <div *ngSwitchCase="'Activity Location'" fxLayout="column">
        <span *ngIf="name==null">-</span>
        <span *ngIf="name!=null">
            {{ name[displayField1] }}
        </span>
        <span *ngIf="name!=null"> {{ name[displayField2] }}
        </span>
    </div>
</div>
<div class="viewLable w-100i" *ngIf="showPurpose">
    <span class="lb-aw">{{ name }}</span>
</div>
